import { useQuery } from '@tanstack/react-query';

import { useAuthContext } from 'context/AuthContext';
import { useRequestListagem } from 'hooks/useRequestListagem';

type UserType = {
    idTipoUsuario: number;
    tipoUsuarioEnum: string;
};

type DeliveryType = {
    idTipoEntrega: number;
    dsTipoEntrega: string;
};

type EmployeeLocal = {
    idLocalFuncionario: number;
    dsLocalFuncionario: string;
};

type StoreType = {
    idTipoLoja: number;
    dsTipoLoja: string;
};

export type Store = {
    idLoja: number;
    dsNomeFantasia: string;
    cdLoja: string;
    dsEmail: string;
    fgAtivo: boolean;
    tipoLoja: StoreType;
};

export type User = {
    idUsuario: number;
    dsUsuario: string;
    cdUsuario: string;
    idCep: number;
    fgAtivo: true;
    loja: Store;
    tipoUsuario: UserType;
    tipoEntrega: DeliveryType | null;
    localFuncionario: EmployeeLocal | null;
    grupos: number[];
};

export function useQueryUser() {
    const { stopTokenRenewal } = useAuthContext();
    const requestListagem = useRequestListagem();

    return useQuery<User>({
        queryKey: ['user'],
        queryFn: () =>
            requestListagem({
                url: '/gestao/usuarioacessowrapper/logado',
            }).then((res) => res.data.data),
        onSuccess: (data) => {
            if (!data || !data.loja) stopTokenRenewal();
        },
        onError: stopTokenRenewal,
    });
}
